"use client";

import { RangeCalendar as HeroRangeCalendar } from "@heroui/react";
import { cn } from "../../lib/utils";

export const RangeCalendar = ({
  className,
  ...props
}: { className?: string } & React.ComponentProps<typeof HeroRangeCalendar>) => {
  return <HeroRangeCalendar className={cn(className)} {...props} />;
};
